import {
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  Create,
  useGetList,
  Loading,
  Toolbar,
  SaveButton,
} from "react-admin";
import {
  Typography,
  CardContent,
  Card,
  Box,
  Divider,
  Grid,
} from "@mui/material";
import ComponentEdit from "../../components/PageComponents/ComponentEdit";
import FormField from "../../components/Common/FormField";
import { useTranslation } from "react-i18next";

export const AccountCreate = () => {
  const { t }: { t: any } = useTranslation();
  const { data, isLoading, error } = useGetList("accounts");

  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return <p>ERROR</p>;
  }
  return  (
    <ComponentEdit
      title={t("New account")}
      subtitle={t("Create a client or reseller account, then add its users and entities.")}
    >
      <Card>
        <Box
          p={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="h6">
              {t("Account details")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("A reseller account can have client accounts attached to it.")}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <CardContent
          sx={{
            p: 4,
          }}
        >
          <Create redirect="show" >
              <SimpleForm toolbar={<Toolbar sx={{ m: 2 }}><SaveButton label={t("Create account")} /></Toolbar>}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <FormField label={t("Name")}>
                      <TextInput source="name" label={t("Name")} fullWidth />
                    </FormField>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormField label={t("Parent reseller account")}>
                      <SelectInput
                        label={t("Parent reseller account")}
                        source="parentAccountId"
                        fullWidth
                        choices={data
                          .filter((account) => account.isReseller)
                          .map((account) => ({ id: account.id, name: account.name }))}
                      />
                    </FormField>
                  </Grid>
                  <Grid item xs={12}>
                    <FormField label={t("Reseller")}>
                      <BooleanInput source="isReseller" label={t("Reseller account")} defaultValue={false} />
                    </FormField>
                  </Grid>
                </Grid>
              </SimpleForm>
            </Create>
        </CardContent>
      </Card>
    </ComponentEdit>
  )
};
